/* ============================================================
   FONKYKROFT THEME — scripts.js
   ============================================================ */

(function () {
  'use strict';

  /* ── Utilities ──────────────────────────────────────────── */
  function $(selector, context) {
    return (context || document).querySelector(selector);
  }
  function $$(selector, context) {
    return Array.from((context || document).querySelectorAll(selector));
  }
  function on(el, event, fn) {
    if (el) el.addEventListener(event, fn);
  }

  /* ── Header Search ──────────────────────────────────────── */
  function initSearch() {
    var toggle = $('#search-toggle');
    var close = $('#search-close');
    var bar = $('#header-search');
    var input = bar && bar.querySelector('input');

    on(toggle, 'click', function () {
      var open = bar.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', open);
      if (open && input) {
        setTimeout(function () { input.focus(); }, 80);
      }
    });
    on(close, 'click', function () {
      bar.classList.remove('is-open');
      toggle.setAttribute('aria-expanded', 'false');
    });
    on(document, 'keydown', function (e) {
      if (e.key === 'Escape' && bar && bar.classList.contains('is-open')) {
        bar.classList.remove('is-open');
        toggle.setAttribute('aria-expanded', 'false');
      }
    });
  }

  /* ── Mobile Menu ────────────────────────────────────────── */
  function initMobileMenu() {
    var btn = $('#mobile-menu-toggle');
    var menu = $('#mobile-menu');

    on(btn, 'click', function () {
      var open = menu.classList.toggle('is-open');
      btn.setAttribute('aria-expanded', open);
      menu.setAttribute('aria-hidden', !open);
    });

    $$('.mobile-menu__sub-toggle').forEach(function (toggle) {
      on(toggle, 'click', function () {
        var sub = toggle.nextElementSibling;
        if (sub) sub.classList.toggle('is-open');
        var expanded = toggle.getAttribute('aria-expanded') === 'true';
        toggle.setAttribute('aria-expanded', !expanded);
      });
    });
  }

  /* ── Sidebar Filter Toggles ─────────────────────────────── */
  function initFilterToggles() {
    $$('.sidebar__filter-toggle').forEach(function (btn) {
      on(btn, 'click', function () {
        var body = btn.nextElementSibling;
        var expanded = btn.getAttribute('aria-expanded') === 'true';
        btn.setAttribute('aria-expanded', !expanded);
        if (body) body.classList.toggle('is-hidden');
      });
    });
  }

  /* ── Mobile Filter Panel ────────────────────────────────── */
  function initMobileFilter() {
    var btn = $('#mobile-filter-btn');
    var sidebar = $('#collection-sidebar');
    if (!btn || !sidebar) return;

    on(btn, 'click', function () {
      sidebar.classList.toggle('is-open');
      document.body.style.overflow = sidebar.classList.contains('is-open') ? 'hidden' : '';
    });

    // Close on outside click
    on(document, 'click', function (e) {
      if (sidebar.classList.contains('is-open') &&
          !sidebar.contains(e.target) &&
          e.target !== btn) {
        sidebar.classList.remove('is-open');
        document.body.style.overflow = '';
      }
    });
  }

  /* ── Collection Sort ────────────────────────────────────── */
  function initCollectionSort() {
    $$('#SortBy, #SortBy-mobile').forEach(function (select) {
      on(select, 'change', function () {
        var url = new URL(window.location.href);
        url.searchParams.set('sort_by', select.value);
        window.location.href = url.toString();
      });
    });
  }

  /* ── Product Gallery Thumbnails ──────────────────────────── */
  function initProductGallery() {
    var mainImg = $('#main-product-image');
    if (!mainImg) return;

    $$('.product-gallery__thumb').forEach(function (thumb) {
      on(thumb, 'click', function () {
        var url = thumb.dataset.imageUrl;
        if (url) {
          mainImg.src = url;
          $$('.product-gallery__thumb').forEach(function (t) { t.classList.remove('is-active'); });
          thumb.classList.add('is-active');
        }
      });
    });

    // Simple zoom on click
    on(mainImg.parentElement, 'click', function () {
      mainImg.parentElement.classList.toggle('is-zoomed');
    });
  }

  /* ── Product Tabs ────────────────────────────────────────── */
  function initProductTabs() {
    var tabs = $$('.product-tabs__btn');
    if (!tabs.length) return;

    tabs.forEach(function (btn) {
      on(btn, 'click', function () {
        var tabId = btn.dataset.tab;
        tabs.forEach(function (t) {
          t.classList.remove('is-active');
          t.setAttribute('aria-selected', 'false');
        });
        $$('.product-tab').forEach(function (p) { p.classList.add('is-hidden'); });
        btn.classList.add('is-active');
        btn.setAttribute('aria-selected', 'true');
        var panel = $('#tab-' + tabId);
        if (panel) panel.classList.remove('is-hidden');
      });
    });
  }

  /* ── Quantity Controls ───────────────────────────────────── */
  function initQtyControls() {
    $$('.qty-btn').forEach(function (btn) {
      on(btn, 'click', function () {
        var input = btn.parentElement.querySelector('.qty-input');
        if (!input) return;
        var val = parseInt(input.value, 10) || 1;
        if (btn.classList.contains('qty-btn--plus')) {
          input.value = val + 1;
        } else if (btn.classList.contains('qty-btn--minus') && val > 1) {
          input.value = val - 1;
        }
        // If on cart page, trigger update
        var line = btn.dataset.line;
        if (line) {
          input.value = parseInt(input.value, 10);
        }
      });
    });
  }

  /* ── Add to Cart (AJAX) ──────────────────────────────────── */
  function initAddToCart() {
    $$('.product-card__form').forEach(function (form) {
      on(form, 'submit', function (e) {
        e.preventDefault();
        var btn = form.querySelector('.product-card__add-btn');
        var data = new FormData(form);

        btn.disabled = true;
        btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" class="spin"><circle cx="12" cy="12" r="10"/><path d="M12 6v6l4 2"/></svg> Adding...';

        fetch('/cart/add.js', {
          method: 'POST',
          body: data,
          headers: { 'X-Requested-With': 'XMLHttpRequest' }
        })
        .then(function (r) { return r.json(); })
        .then(function () {
          btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><polyline points="20 6 9 17 4 12"/></svg> Added!';
          btn.style.background = '#16a34a';
          updateCartCount();
          setTimeout(function () {
            btn.disabled = false;
            btn.innerHTML = '<svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M6 2L3 6v14a2 2 0 002 2h14a2 2 0 002-2V6l-3-4z"/><line x1="3" y1="6" x2="21" y2="6"/><path d="M16 10a4 4 0 01-8 0"/></svg> Add to Cart';
            btn.style.background = '';
          }, 2000);
        })
        .catch(function () {
          btn.disabled = false;
          btn.innerHTML = 'Try Again';
        });
      });
    });
  }

  /* ── Cart Count Update ───────────────────────────────────── */
  function updateCartCount() {
    fetch('/cart.js', { headers: { 'X-Requested-With': 'XMLHttpRequest' } })
    .then(function (r) { return r.json(); })
    .then(function (cart) {
      var badge = $('.cart-count');
      if (cart.item_count > 0) {
        if (!badge) {
          var cartBtn = $('.header-icon-btn--cart');
          if (cartBtn) {
            badge = document.createElement('span');
            badge.className = 'cart-count';
            cartBtn.appendChild(badge);
          }
        }
        if (badge) badge.textContent = cart.item_count;
      }
    });
  }

  /* ── Product Page Add to Cart ────────────────────────────── */
  function initProductForm() {
    var form = $('#product-form');
    if (!form) return;

    var addBtn = form.querySelector('.product-form__add-btn');
    if (!addBtn) return;

    on(form, 'submit', function (e) {
      e.preventDefault();
      addBtn.disabled = true;
      addBtn.textContent = 'Adding...';

      var data = new FormData(form);
      fetch('/cart/add.js', {
        method: 'POST',
        body: data,
        headers: { 'X-Requested-With': 'XMLHttpRequest' }
      })
      .then(function (r) { return r.json(); })
      .then(function () {
        addBtn.textContent = '✓ Added to Cart!';
        addBtn.style.background = '#16a34a';
        updateCartCount();
        setTimeout(function () {
          addBtn.disabled = false;
          addBtn.textContent = 'Add to Cart';
          addBtn.style.background = '';
        }, 3000);
      })
      .catch(function () {
        addBtn.disabled = false;
        addBtn.textContent = 'Add to Cart';
      });
    });

    // Buy Now
    var buyNow = form.querySelector('.product-form__buy-now');
    on(buyNow, 'click', function (e) {
      e.preventDefault();
      var variantId = $('#variant-id');
      if (variantId) {
        window.location.href = '/checkout?variant=' + variantId.value + '&quantity=1';
      }
    });
  }

  /* ── Variant Selection ───────────────────────────────────── */
  function initVariantSelection() {
    $$('.variant-option').forEach(function (btn) {
      on(btn, 'click', function () {
        var group = btn.closest('.variant-group');
        $$('.variant-option', group).forEach(function (b) { b.classList.remove('is-selected'); });
        btn.classList.add('is-selected');
      });
    });
  }

  /* ── Lazy Load Images ────────────────────────────────────── */
  function initLazyLoad() {
    if ('loading' in HTMLImageElement.prototype) return; // Native lazy loading supported
    var images = $$('img[loading="lazy"]');
    if (!images.length) return;

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          var img = entry.target;
          if (img.dataset.src) img.src = img.dataset.src;
          observer.unobserve(img);
        }
      });
    }, { rootMargin: '200px 0px' });

    images.forEach(function (img) { observer.observe(img); });
  }

  /* ── Scroll Reveal ───────────────────────────────────────── */
  function initScrollReveal() {
    if (!window.IntersectionObserver) return;
    $$('.product-card, .category-card, .trust-badge, .brand-card').forEach(function (el) {
      el.style.opacity = '0';
      el.style.transform = 'translateY(16px)';
      el.style.transition = 'opacity 0.5s ease, transform 0.5s ease';
    });

    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.style.opacity = '1';
          entry.target.style.transform = 'none';
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.08, rootMargin: '0px 0px -32px 0px' });

    $$('.product-card, .category-card, .trust-badge, .brand-card').forEach(function (el) {
      observer.observe(el);
    });
  }

  /* ── Sticky Header Shadow ────────────────────────────────── */
  function initStickyHeader() {
    var header = $('#site-header');
    if (!header) return;
    on(window, 'scroll', function () {
      header.style.boxShadow = window.scrollY > 10 ? '0 2px 20px rgba(0,0,0,0.12)' : '';
    });
  }

  /* ── Init ────────────────────────────────────────────────── */
  document.addEventListener('DOMContentLoaded', function () {
    initSearch();
    initMobileMenu();
    initFilterToggles();
    initMobileFilter();
    initCollectionSort();
    initProductGallery();
    initProductTabs();
    initQtyControls();
    initAddToCart();
    initProductForm();
    initVariantSelection();
    initLazyLoad();
    initScrollReveal();
    initStickyHeader();
  });

})();

// FAQ Accordion — Contact Page
function initContactFaq() {
  var buttons = document.querySelectorAll('.faq-item__question');
  if (!buttons.length) return;

  buttons.forEach(function(btn) {
    btn.addEventListener('click', function() {
      var answerId = btn.getAttribute('aria-controls');
      var answer = document.getElementById(answerId);
      var isOpen = btn.getAttribute('aria-expanded') === 'true';

      buttons.forEach(function(b) {
        b.setAttribute('aria-expanded', 'false');
        var a = document.getElementById(b.getAttribute('aria-controls'));
        if (a) a.classList.remove('is-open');
      });

      if (!isOpen && answer) {
        btn.setAttribute('aria-expanded', 'true');
        answer.classList.add('is-open');
      }
    });
  });
}

document.addEventListener('DOMContentLoaded', function() {
  initContactFaq();
});